<template>
  <fade-transition>
    <b-alert v-model="visible" variant="neutral" :class="`border border-${getBorderColor()}`" role="alert">
      <template>
        <template>
          <slot name="icon">
            <span class="alert-icon" data-notify="icon">
              <i :class="`${getIcon()} text-${getIconColor()}`"></i>
            </span>
          </slot>
        </template>

        <span :class="`alert-text`"> <slot></slot> </span>

        <base-button :type="`${getIconColor()}`" class="btn-sm" v-if="action" @click="action.callback">
          {{action.label}}
        </base-button>

        <slot name="dismiss-icon" v-if="dismissible">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="dismissAlert">
            <span aria-hidden="true">×</span>
          </button>
        </slot>
      </template>
    </b-alert>
  </fade-transition>
</template>
<script>
import { FadeTransition } from 'vue2-transitions';

export default {
  name: 'base-alert',
  components: {
    FadeTransition
  },
  props: {
    type: {
      type: String,
      default: 'info',
      description: 'Alert type'
    },
    action: {
      type: Object,
      default: null,
    },
    dismissible: {
      type: Boolean,
      default: false,
      description: 'Whether alert is dismissible (closeable)'
    },
    icon: {
      type: String,
      default: '',
      description: 'Alert icon to display'
    }
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    dismissAlert() {
      this.visible = false;
    },
    getIcon() {
      let iconString = ''
      switch(this.type) {
        case 'info':
          iconString = 'info';
          break;
        case 'danger':
          iconString = 'exclamation-circle';
          break;
        case 'warning':
          iconString = 'exclamation-triangle';
          break;
        case 'success':
          iconString = 'check-circle';
          break;
      }
      return `fas fa fa-${iconString}`
    },
    getIconColor() {
      switch(this.type) {
        case 'info':
          return 'primary';
        case 'warning':
          return 'warning';
        case 'danger':
          return 'danger';
        case 'success':
          return 'success';
      }
    },
    getBorderColor() {
      switch(this.type) {
        case 'info':
          return 'lighter';
        case 'warning':
          return 'warning';
        case 'danger':
          return 'danger';
        case 'success':
          return 'success';
      }
    }
  }
};
</script>
